import { Injectable } from '@angular/core';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { Annonce } from '../../common/models/annonce';

import { Annulation } from './models/Annulation';
import { TypeLieu } from './models/TypeLieu';
import { TypeVoie } from './models/TypeVoie';
import { AnnulationService } from './services/annulation/annulation.service';
import { CommonService } from '../../common/services/common/common.service';
import { DIVERS } from '../common/models/Typedivers';
import { DiversService } from '../common/services/divers/divers.service';
import { TypeAvisEnum } from '../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class FormDiversAnnulationExtractorService {

  constructor(private formExtractorService: FormExtractorService,
    private annulationService: AnnulationService,
    private diversService: DiversService,
    private commonService: CommonService,
    private avisDataTransferService: AvisDataTransferService) { }

  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
    const annulation = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.annulation;

    if (stepId === 1) {
      annulation.avisInitial =
      this.annulationService.avisInitialService.getAvisInitial(controls);
    }
    if (stepId === 3) {
      annulation.description = this.annulationService.descriptionService.getDescription(controls, this.formExtractorService);
      annulation.objet = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_objet');
      annulation.typeProcedure = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_procedure') == null ? '' : controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_procedure');
      const lieuExecutionLivraison = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_lieuExecutionCB')
      if(lieuExecutionLivraison) {
        annulation.lieuLivraison = null;
        annulation.lieuExecution = null;

        annulation.lieuExecutionLivraison = new TypeLieu();
        annulation.lieuExecutionLivraison.cp = controls.get('lieuExecutionLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp');
        annulation.lieuExecutionLivraison.ville = controls.get('lieuExecutionLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_ville');

        annulation.lieuExecutionLivraison.voie = new TypeVoie();
        annulation.lieuExecutionLivraison.voie.typevoie = controls.get('lieuExecutionLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie');
        annulation.lieuExecutionLivraison.voie.nomvoie = controls.get('lieuExecutionLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie');
        annulation.lieuExecutionLivraison.voie.num = controls.get('lieuExecutionLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num');
      } else {

        annulation.lieuExecutionLivraison = null;

        annulation.lieuLivraison = new TypeLieu();
        annulation.lieuLivraison.cp = controls.get('lieuLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp');
        annulation.lieuLivraison.ville = controls.get('lieuLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_ville');
        annulation.lieuLivraison.voie = new TypeVoie();
        annulation.lieuLivraison.voie.typevoie = controls.get('lieuLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie');
        annulation.lieuLivraison.voie.num = controls.get('lieuLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num');
        annulation.lieuLivraison.voie.nomvoie = controls.get('lieuLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie');

        annulation.lieuExecution = new TypeLieu();
        annulation.lieuExecution.cp = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp');
        annulation.lieuExecution.ville = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_ville');
        annulation.lieuExecution.voie = new TypeVoie();
        annulation.lieuExecution.voie.num = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num');
        annulation.lieuExecution.voie.typevoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie');
        annulation.lieuExecution.voie.nomvoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie');
      }
    }
    if (stepId === 4) {
      annulation.infosAnnulation = controls.get('_SepSep_Annulation_SepAtt_infosAnnulation');
    }

    const divers: DIVERS = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers;
    if (stepId === 2) {
			divers.organisme = this.diversService.typeAdresseCompleteObligatoireService.getTypeAdresseCompleteObligatoire(controls);
    }
		divers.initial = null;
		divers.attribution = null;
		divers.rectificatif = null;
    divers.annulation = annulation;

    const annonce: Annonce = new Annonce();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
    annonce.ann.divers = divers;
		annonce.ann.mapa = null;
		annonce.ann.fnSimple = null;
		annonce.ann.formAD = null;
    annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
    annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
    annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		
    let avis: Avis = new Avis();

    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.DIVE_AN];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code=TypeAvisEnum.C4_5;

    return avis;
  }
}
